export default __webpack_public_path__ + "static/caf-88c57cae8316e5ad33859758f8949c20.jpg";